import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Switch } from 'react-router-dom';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { MultiContainerHeader } from '../../components/MultiContainerHeader';
import { NavigationBreadcrumbsBar } from '../../components/NavigationBreadcrumbsBar';
import { PrivateRoute } from '../../components/PrivateRoute';
import { CustomSurvey } from '../../containers/SurveyCreation/CustomSurvey';
import { DonationSurvey } from '../../containers/SurveyCreation/DonationSurvey';
import { EventRegistrationSurvey } from '../../containers/SurveyCreation/EventRegistrationSurvey';
import { SatisfactionSurvey } from '../../containers/SurveyCreation/SatisfactionSurvey';
import { baseStyleSheet } from '../../styles/styles';

const LazySurveysTabsRoute = React.lazy(() => import('./index'));

const styleSheet = StyleSheet.create({
	loadingSpinnerContainer: {
		height: '100%',
		position: 'relative',
		width: '100%',
	},
});

export const LazySurveysRoute: React.FC = () => {
	const userSession = useUserSession();
	const spinner = React.useMemo(() => {
		return (
			<div className={css(styleSheet.loadingSpinnerContainer)}>
				<MultiContainerHeader appBarHeader={<NavigationBreadcrumbsBar />} />
				<LoadingSpinner className={css(baseStyleSheet.absoluteCenter)} type='large' />
			</div>
		);
	}, []);
	return (
		<Switch>
			<PrivateRoute path='/surveys/event/edit/:id?' userSession={userSession}>
				<EventRegistrationSurvey />
			</PrivateRoute>
			<PrivateRoute path='/surveys/satisfaction/edit/:id?' userSession={userSession}>
				<SatisfactionSurvey />
			</PrivateRoute>
			<PrivateRoute path='/surveys/custom/edit/:id?' userSession={userSession}>
				<CustomSurvey />
			</PrivateRoute>
			{userSession?.account?.features?.boards?.donationBoard?.enabled &&
			!userSession.hasNonProfitIntegrationConfigured &&
			userSession.account.stripePayment.enabled ? (
				<PrivateRoute path='/surveys/donation/edit/:id?' userSession={userSession}>
					<DonationSurvey />
				</PrivateRoute>
			) : null}
			<PrivateRoute path='/surveys' userSession={userSession}>
				<React.Suspense fallback={spinner}>
					<LazySurveysTabsRoute />
				</React.Suspense>
			</PrivateRoute>
		</Switch>
	);
};
